import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { Headline } from './Headline'

export interface HeadlineProps {
    text: string
}

export const HeadlineRegistration = createRegisterableComponent(
    'headline',
    (props: HeadlineProps) => {
        return <Headline text={props.text} />
    },
)
